import * as Modern from './modern';
import * as Standard from './standard';
import * as Professionell from './professionell';

export const TEMPLATES = {
  modern:        { id: 'modern',        name: 'Modern',        Kopf: Modern.Kopf,        Sektion: Modern.Sektion,        Footer: Modern.Footer        },
  standard:      { id: 'standard',      name: 'Standard',      Kopf: Standard.Kopf,      Sektion: Standard.Sektion,      Footer: Standard.Footer      },
  professionell: { id: 'professionell', name: 'Professionell', Kopf: Professionell.Kopf, Sektion: Professionell.Sektion, Footer: Professionell.Footer },
};

export function getTemplate(id) {
  return TEMPLATES[id] ?? TEMPLATES.standard;
}

/** Leitet Template-ID aus Stelle ab */
export function inferTemplateId(stelle, sektionen) {
  const explicit = stelle?.cv_vorlage?.replace(/^cv_/, '') ?? stelle?.cv_data?.vorlage;
  if (explicit === 'modern') return 'modern';
  if (explicit === 'professionell') return 'professionell';
  if (explicit) return 'standard'; // psyfix und unbekannte → standard
  if (stelle?.cv_data) {
    return (stelle.cv_data.sektionen || []).some(s => s.typ === 'kenntnisse') ? 'modern' : 'standard';
  }
  return stelle?.cv_rohtext?.includes('KTITEL:') ? 'modern' : 'standard';
}
